import { Instance } from 'mobx-state-tree';
import { CompletedRoutesInsightsDtoModelBase } from './CompletedRoutesInsightsDtoModel.base';

/* The TypeScript type of an instance of CompletedRoutesInsightsDtoModel */
export interface CompletedRoutesInsightsDtoModelType extends Instance<typeof CompletedRoutesInsightsDtoModel.Type> {}

/* A graphql query fragment builders for CompletedRoutesInsightsDtoModel */
export { selectFromCompletedRoutesInsightsDto, completedRoutesInsightsDtoModelPrimitives, CompletedRoutesInsightsDtoModelSelector } from './CompletedRoutesInsightsDtoModel.base';

/**
 * CompletedRoutesInsightsDtoModel
 */
export const CompletedRoutesInsightsDtoModel = CompletedRoutesInsightsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
